// Elenco delle news
import React from 'react';
import { get, set } from './Storage';
import axios from 'axios';
import CircularProgress from 'material-ui/CircularProgress';
import { Message } from "mgUiKit";
import WidgetGroup from './Widget/WidgetGroup';
import WidgetAccount from './Widget/Account';
import WidgetUserInfo from './Widget/UserInfo';
import TicketsListPage from './Page/TicketsList';
import DepositToolsPage from './Page/DepositTools';
import WithdrawalTools from './Page/WithdrawalTools';
import MemobetListPage from './Page/MemobetList';
import KeepAlive from './KeepAlive';
import { MGSiteButton } from 'mgUiKit';

import PropTypes from 'prop-types';
import WidgetTool from './Widget/WidgetTool';
import Assistenza from './Widget/Assistenza';
import WidgetMission from './Widget/WidgetMission';
import LoyaltySystemBadge from './Widget/LoyaltySystemBadge';
import DashboardPVRToolbar from './DashboardPVRToolbar';
import MasterAgentBadge from './Widget/MasterAgentBadge';


// Init Configuration
var AppSettings = get();
var componentName = AppSettings.appId + 'TabProfileComponent';

/*CSS Styles Radium*/
var styles = AppSettings.styles;

class TabProfile extends React.Component {

    constructor(props, context) {
        super(props);
        this.state = {
            data: {},
            error: false,
            showBalance: AppSettings['balanceOpened'],
            balance: "",
            bonusBalance:"",
            coupons:[],            
            withdrawable: "",
            fido: "",
            showLoading: true,
            errorMessage: "",
            countMission: context.countMission,
            showBonusList:false, 
        }

        this.loadTabProfile = this.loadTabProfile.bind(this);
        this.handleToggleBalance = this.handleToggleBalance.bind(this);
        this.refreshBalance = this.refreshBalance.bind(this);
        this.handleToggleBonusList = this.handleToggleBonusList.bind(this);       
        this.openControPanel = this.openControPanel.bind(this);
        
    }

    componentDidMount() {
        if (AppSettings['balanceOpened']) {
            let data = this.context.getExternalToolbarBalance();
            if(data == null){
                this.refreshBalance();
            }
            else{
                this.setState({
                    balance: data.balance,
                    bonusBalance: data.bonusBalance,
                    withdrawable: data.withdrawable,
                    fido: data.fidoStr,
                    showBalance: true
                });
            }
        }

        this.loadTabProfile();
    }

    loadCoupons(){
        // this.state.bonusBalance
        if(this.state.bonusBalance !="0" && this.state.bonusBalance!="€ 0,00"
            && this.state.coupons.length == 0){
            let coupons=[];
            var urlUserBoxTabCoupon = AppSettings['env'].urlUserBoxTabCoupon;
            axios.get(urlUserBoxTabCoupon)
                .then(({ data, status, statusText }) => {
                    if (data.errors.length == 0) {
                        if (data.coupons.length > 0)
                            coupons = data.coupons;
                        this.setState({
                            coupons: coupons
                        });
                    } else {
                        this.setState({
                            coupons: coupons
                        });
                    }
                })
                .catch(function (error) { });
            }
    }

    loadTabProfile() {
        this.setState({
            showLoading: true,
        });

        var url = AppSettings['env'].urlUserBoxTabProfile;
        axios.get(url)
        .then(({ data, status, statusText }) => {
            let withdrawable = "";
            if (data.errors.length == 0) {

                if (data.withdrawal != null) {
                    withdrawable = data.withdrawal;
                }

                AppSettings["lastLogin"] = data.lastLogin;
                set(AppSettings);
                    
                    
                let  currentState = {
                    data: data,
                    error: false,
                    showLoading: false,
                };
                    
                
                    
                    this.setState(currentState);

                    this.context.checkIsAlertProfileActive(data.messages.length > 0);
                } else {
                    this.setState({
                        data: {},              
                        withdrawable: "",
                        error: true,
                        showLoading: false,
                        errorMessage: <KeepAlive />
                    });
                }
            })

            .catch(function (error) {
                this.setState({
                    error: true,
                    showLoading: false,
                    showBalance: false,
                    errorMessage: ""
                });
            });
    }

    refreshBalance() {
        let that = this;
        this.setState({
            showBalance: true,
            balance: "---",
            bonusBalance:"---",
            withdrawable:"---",
            fido: '---'
        });
        var balance = "---";
        var bonusBalance="0";
        var fido = "";
        var withdrawable = "";
        var url = AppSettings['env'].urlUserBoxGetBalance;
        axios.get(url)
            .then(({ data, status, statusText }) => {
                this.context.setExternalToolbarBalance(data);
                if (data.errors.length == 0) {
                    this.context.setBalanceData(data);
                    balance = data.balance;
                    if(data.bonusBalance !=null){
                        bonusBalance = data.bonusBalance;
                    } 
                    fido = data.fidoStr;
                    withdrawable = data.withdrawable;
                    document.querySelectorAll("[data-ub-balance]").forEach(function (el) { el.innerHTML = balance });
                    document.querySelectorAll("[data-ub-bonus]").forEach(function(el){ el.innerHTML = bonusBalance });
                    document.querySelectorAll("[data-ub-min-balance]").forEach(function(el){ el.innerHTML = fido });
                    that.statusBalance(true);
                }
                this.setState({
                    balance: balance,
                    bonusBalance:bonusBalance,
                    withdrawable:withdrawable,
                    showBalance: true,
                    fido: fido
                });
                window.postMessage({"action":"PM_MG_RENDER_AFTER_REFRESH"}, "*");
            })

            .catch(({ data, status, statusText }) => {
                this.setState({
                    balance: "---",
                    bonusBalance:"---",
                    withdrawable:"---",
                    fido:"---",
                    showBalance: true
                });
            });
    }

    //mostra/nascondi vari saldi
    handleToggleBalance() {
        let that = this;
        if (this.state.showBalance === true) {
            this.setState({
                showBalance: false,                
                showBonusList:false                
            });
            document.querySelectorAll("[data-ub-balance]").forEach(function(el){ el.innerHTML = "---" });
            document.querySelectorAll("[data-ub-bonus]").forEach(function(el){ el.innerHTML = "---" });
            document.querySelectorAll("[data-ub-min-balance]").forEach(function(el){ el.innerHTML = '---' });
            that.statusBalance(false);
        } else {

            this.refreshBalance();
            this.setState({
                showBalance: true,                
                showBonusList: true,                           
                
            });
                    
        }
    }

    statusBalance(status){
        AppSettings['balanceOpened'] = status
        set(AppSettings);
        if (typeof (Storage) !== "undefined") {
            localStorage.setItem(AppSettings["env"].localStorageToggleBalance, status);
        }
        // Pvr panel
        let dashboardPvr = document.getElementById("mg-pvr-balance");
        let elmSwt = document.getElementById("switch-balance");
        if(dashboardPvr != null && elmSwt != null) {
            elmSwt.checked = status;
            if(status){
                dashboardPvr.classList.add('show');
            }
            else{
                dashboardPvr.classList.remove('show');

            }
        }
    }

    handleToggleBonusList() {
        this.loadCoupons();
        this.setState({
            showBonusList: !this.state.showBonusList,
        });
    }

    renderMessages() {
        var messages = null;
        if (this.state.data.messages.length > 0) {

            messages = this.state.data.messages.map(function (message, i) {
                var key = "msg_" + i;
                return (
                    <Message key={key} type="warning" align="left"><span dangerouslySetInnerHTML={{ __html: message }} /></Message>
                )
            });

        }
        return messages
    }

    // Costruzione output tab panel
    renderProfile() {

        let statementOfAccount = "/statementOfAccount";
        let pvrDashBoardOpenModal = false;

        //Nel caso di portali 
        if (AppSettings.isnetworksite == "true") {
            statementOfAccount = AppSettings.urls.statementOfAccount.href;
        }

        if (AppSettings['isPartner']
            && typeof _dashboardPVRInstance != 'undefined'
            && AppSettings['perms'].dashboardpvr) {
            statementOfAccount = "/pvr-estratto-conto";
            pvrDashBoardOpenModal = true;
        }
        var clickEventEstrattoConto = (e) => {

            if (pvrDashBoardOpenModal) {
                e.stopPropagation();
                e.preventDefault();
                let settings = {
                    url: statementOfAccount,
                    modal: true,
                    cssClass: "iframe",
                    iframe: true
                };
                window._dashboardPVRInstance.openModal(settings);

            } else {
                this.context.openLinkPopup(e, statementOfAccount);
            }
        }

        let assistenza = null;
        try {
            //verifico la presenza dell'assistenza sulla userbox
            if (window._site != null && window._site.assistenza != null && window._site.assistenza.isActive) {
                //prelevo quella dedicata alla userbox
                window._site.assistenza.content.assistenza.forEach(element => {
                    if (element.type == "userbox" && element.active) {
                        assistenza = element.value;
                        return;
                    }
                });

            }
        }
        catch (err) { }

        var couponsList = [];
        const groupBy = (array, property) => array.reduce((grouped, element) => ({
            ...grouped,
            [element[property]]: [...(grouped[element[property]] || []), element]
          }), {})
        var couponsGroupByService= groupBy(this.state.coupons, "serviceCode");        
        var services = Object.keys(couponsGroupByService);
        var serviceMappings = {
            "PSR": "Giochi al totalizzatore",
            "PCP": "Giochi a pronostico",
            "GNTN": "Giochi numerici",
            "SkillGames": "Giochi di abilità",
            "PSV": "Scommesse virtuali",
            "PSQF": "Scommesse sportive",
            "PSIP": "Scommesse ippiche al totalizzatore",
            "PGAD": "Generico",
            "Casino": "Casino online",
            "CasinoLive": "Casino live",
            "Bingo": "Bingo",
            "Poker": "Poker sportivo",
            "LOL":"Lotto"
        };        
        for (let j = 0; j < services.length; j++) {
            var key = services[j] + "-" +j;
            var itemClass = "coupon-item";            
            var amount=0;
            for(let i=0;i<couponsGroupByService[services[j]].length;i++){
                var c=couponsGroupByService[services[j]][i];
                var camount=Number(c.amount.replace(/[€ ]+/g,"").replace(',', '.'))
                amount +=camount;
            }
              // Create our number formatter.
              const formatter = new Intl.NumberFormat('it-IT', {
                style: 'currency',
                currency: 'EUR',

            // These options are needed to round to whole numbers if that's what you want.
            //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
            //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
              });  
            var formattedAmount="€ "+formatter.format(amount).replace(/[ €]/,"").trim(); /* $2,500.00 */
            let mappedService="";
             try {
                mappedService=serviceMappings[services[j]];
             } catch (error) {
                mappedService=services[j];
             } 
                couponsList.push(
                    <div key={key} id={services[j]} 
                            className={itemClass}>
                            <span className="ub-saldo--titolo">{mappedService}</span>
                             <span className="ub-saldo--importo"> 
                                    {formattedAmount}
                                </span>                           

                    </div>
                );
        }
				
        

        return (
            <>
                <MasterAgentBadge label={false} />
                {this.renderMessages()}

                {/* <WidgetUserInfo username={this.state.data.username} ssn={this.state.data.ssn} typeUser={this.state.data.usernameDescription} /> */}
                {AppSettings['isPartner'] && <DashboardPVRToolbar/>}
                <div id="ub-box-saldo">
                    <WidgetUserInfo username={this.state.data.username} ssn={this.state.data.ssn} typeUser={this.state.data.usernameDescription} />
                    <LoyaltySystemBadge/>
                    <div id="ub-saldo-utente">
                        <div id="ub-saldo-intro">
                            <span className="mg-saldo--titolo" onClick={this.openControPanel}>Il tuo conto</span>
                            <div id="ub-saldo--control">
                                {this.state.showBalance === true ?
                                    <i title='Nascondi' className="info-balance_control control-hide" onClick={this.handleToggleBalance}></i> :
                                    <i title='Mostra' className="info-balance_control control-show" onClick={this.handleToggleBalance}></i>
                                }
                                <i title="Aggiorna" className="info-balance_refresh" onClick={this.refreshBalance}></i>
                            </div>
                        </div>

                        <div id="ub-saldo-disponibile">
                            <span className="ub-saldo--titolo">Saldo disponibile</span>
                            <span className="ub-saldo--importo">  {this.state.showBalance ? this.state.balance : "---"}</span>
                        </div>
                                    
                        {!AppSettings['isPartner'] ?
                            <div id="ub-saldo-prelevabile">
                                <span className="ub-saldo--titolo">Saldo prelevabile</span>
                                <span className="ub-saldo--importo">{this.state.showBalance ? this.state.withdrawable : "---"}</span>
                            </div>
                            : null}
                       
                       {/* {this.state.bonusBalance!="0" && this.state.bonusBalance!="€ 0,00"? */}
                        {!AppSettings['isPartner'] ? <div id="ub-saldo-bonus" className={this.state.showBonusList?"saldo-bonus--active":""}>
                            <span className="ub-saldo--titolo" >Saldo bonus
                            {this.state.bonusBalance !="0" && this.state.bonusBalance!="€ 0,00"?<i onClick={this.handleToggleBonusList}></i>:""}
                            </span>
                            <span className="ub-saldo--importo">{this.state.showBalance ? this.state.bonusBalance : "---"}</span>

                        </div> : null}
                        {!AppSettings['isPartner'] && this.state.showBonusList && couponsList.length > 0 ?
                            <div id="ub-coupon-list">
                                {couponsList}
                            </div>
                        : null}
                       
                        {
                            AppSettings['isPartner'] ?
                                <div id="ub-saldo-mb">
                                    <span className="ub-saldo--titolo">Saldo M.B.</span>
                                    <span className="ub-saldo--importo">{this.state.showBalance ? this.state.fido : "---"}</span>
                                </div>
                                : null
                        }
                    </div>

                    {/* Widget VIP System
                    <WidgetVipSystem data={this.state.data} />
                    */}

                    {/* Widget Ricarica e Prelievo */}
                    <div className="ub-buttons-wrap">
                        {AppSettings['perms'].deposit ?
                            <DepositToolsPage />
                            : null}
                        {AppSettings['perms'].withdrawal && AppSettings.mostrabtnpreleva ?
                            <WithdrawalTools />
                            : null}

                        <MGSiteButton
                            title="Estratto Conto"
                            label="Estratto Conto"
                            class=""
                            
                            disabled={false}
                            primary={false}
                            isButton={true}
                            fullWidth={false}
                            actionFunc={clickEventEstrattoConto}
                        />
                        
                    </div>
                </div>

                 {/*Widget LE TUE MISSIONI*/}
                 {(() => {
                if (AppSettings['perms'].tabMissions && this.state.countMission>0 ) {
                    return (
                        
                        <div className="mg-user-widget" id="mg-mission-link">
                            <a title="Le tue missioni" onClick={this.context.openMissionsToolList.bind(this)}>
                                <i className="fa-mg fa-mg-award mg-user-icon"></i>
		                        <div className="mg-mission-title">Le tue missioni<sup className="mg-mission-counter">{this.state.countMission}</sup></div>
		                        <span className="mg-mission-info" >Scopri di più</span>
                            </a>
                        </div>
                    )
                }
                })()}

                {/*Widget IL TUO ACCOUNT*/}
                {(() => {
                    if (AppSettings['perms'].widgetAccount) {
                        return (
                            <WidgetAccount data={this.state.data} />
                        )
                    }
                })()}
                {<WidgetTool />}
                {/*Widget Scommesse Sportive*/}

                {(() => {
                    if (AppSettings['perms'].ticketList || AppSettings['perms'].memobet) {
                        return (
                            <WidgetGroup id="mg-box-scommesse-sportive" icon="fa-mg-betting-2" title="Scommesse sportive" subtitle="Ultime giocate, Memobet">
                                {AppSettings['perms'].ticketList ? <TicketsListPage /> : null}
                                {AppSettings['perms'].memobet ? <MemobetListPage /> : null}
                            </WidgetGroup>
                        );
                    }
                })()}

                {this.renderCaricaDocumenti()}

                {/*se è presente il json di assistenza sotto window._site.assistenza */}
                {assistenza != null ? <Assistenza data={assistenza} /> : ""}

                {/*Widget DETTAGLIO SOTTOCONTI 
                <WidgetSubAccounts />*/}

                {/*Widget Ultimi LOGIN* 
                <WidgetLastLogins /> */}

            </>
        )
    }

    openControPanel(e){
        this.context.openLinkPopup(e, "/controlpanel");
    }

    renderCaricaDocumenti(){
        if(AppSettings.device == "mobile" && typeof verificaUrl  == "string" ){
            let openCaricaDocumenti = (e) => {
                location.href = verificaUrl;
            };
            return (
                <WidgetGroup id="mg-box-carica-documenti" icon="fa-mg-doc" title="Adeguata Verifica" subtitle="Identificazione Conto Gioco">
                    <MGSiteButton
                                    title="Avvia procedura"
                                    label="Avvia procedura"
                                    class="mg-btn-adeguata-verifica"
                                    disabled={false}
                                    primary={true}
                                    isButton={true}
                                    fullWidth={true}
                                    actionFunc={openCaricaDocumenti.bind(this)}
                                />
                </WidgetGroup>
            );
        }
        else{
            return "";
        }
    }


    render() {
        var render;
        if (this.state.showLoading) {
            render = <CircularProgress style={styles.loadingIcon} />;
        }
        else {
            if (this.state.error) {
                render = <Message align="center" type="error">{this.state.errorMessage}</Message>;
            }
            else {
                render = this.renderProfile();
            }
        }
        return render;
    }
}

TabProfile.displayName = componentName;

// PropTypes validation
TabProfile.propTypes = {};

// default props
TabProfile.defaultProps = {};

TabProfile.contextTypes = {
    checkIsAlertProfileActive: PropTypes.func,
    openLinkPopup: PropTypes.func,  
    refreshBalance: PropTypes.func,  
    isAlertProfileActive: PropTypes.bool,  
    countMission: PropTypes.number,
    openMissionsToolList: PropTypes.func,
    getExternalToolbarBalance: PropTypes.func,
    setExternalToolbarBalance: PropTypes.func,
    setBalanceData: PropTypes.func,
}
export default TabProfile;